export async function getAuthData() { // Just get the data, e.g. to use data.isAuthenticated
   const authData = null;
    try {
        const response = await fetch('/auth/status');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch {
        console.error('Error fetching auth status:', error);
        return null;
    };
}
    
export async function checkAuthStatus() { // Update the login controls

    const authStatus = document.getElementById('authStatus'); // <-- Add this line

    if (!authStatus) {
        console.error('authStatus element not found in the DOM.');
        return;
    }

    try {
        const response = await fetch('/auth/status');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.isAuthenticated) {
            authStatus.textContent = 'Authenticated';
            loginButton.style.display = 'none';
            logoutButton.style.display = 'block';
            return data;
        } else {
            authStatus.textContent = 'Not Authenticated';
            loginButton.style.display = 'block';
            logoutButton.style.display = 'none';
            return null;
        }
    } catch (error) {
        console.error('Error checking authentication status:', error);
        authStatus.textContent = 'Error';
    }
}

export async function enableAuthButtons() {

    if (!loginButton || !logoutButton) {
        console.error('Login or Logout button not found in the DOM.');
        return;
    }

    loginButton.addEventListener('click', () => {
        localStorage.setItem('postLoginRedirect', window.location.href);
        window.location.href = '/auth/google/login';
    });

    logoutButton.addEventListener('click', async () => {
        try {
            const response = await fetch('/auth/google/logout', { method: 'POST' });
            if (response.ok) {
                checkAuthStatus(); // Update UI after successful logout
            } else {
                console.error('Logout failed');
            }
        } catch (error) {
            console.error('Error during logout:', error);
        }
    });
}